<div class="profile-container">
  <div class="profile-content">
    <div class="personal-details">
      <div class="header-block">
        <div class="header-title">
          <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="add-block">
          <i class="bi bi-lock" (click)="bulkUpdateObjectInfoLocking(true)" *ngIf="isLockAll"></i>
          <i class="bi bi-unlock" (click)="bulkUpdateObjectInfoLocking(false)" *ngIf="isUnLockAll"></i>
          <div class="search">
            <form autocomplete="off" >
              <input type="text" placeholder="search" (keyup.enter)="getObjectInfoByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
            </form>
            <i class="bi bi-search" (click)="getObjectInfoByWildSearch()"></i>
          </div>
          <button data-toggle="modal" title="Add Asset" data-target="#openAddModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>

          <div class="filter-icon">
            <i class="bi bi-funnel" title="Filter" (click)="toggleFilter()"></i>
            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 table-data" [ngClass]="{'col-lg-9 col-md-9 ': showFilter}">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 5%;" *ngIf="isShowLock"></th>
                <th style="width: 10%;" *ngIf="isShowLock">{{ 'object-info.objectInfoId' | translate }}</th>
                <th style="width: 15%;" *ngIf="!isShowLock">{{ 'object-info.objectInfoId' | translate }}</th>
                <th style="width: 15%;">{{ 'object-info.givenName' | translate }}</th>
                <th style="width: 15%;">{{ 'object-info.zone' | translate }}</th>
                <th style="width: 15%;">{{ 'object-info.city' | translate }}</th>
                <th style="width: 15%;">{{ 'object-info.country' | translate }}</th>
                <th style="width: 15%;">{{ 'object-info.objectCondition' | translate }}</th>
                <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
              </tr>
            </thead>
          </table>
          <div *ngIf="!isLoading">
            <div class="data-view" id="{{list.id}}" [ngClass]="{ 'delete-highlight': list.objectInfoId == recordId }" *ngFor="let list of objectInfoList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
              }  ;let i = index">
              <p style="width: 5%;overflow: hidden;padding-right: 0;" *ngIf="isShowLock">
                <input type="checkbox" [(ngModel)]="list.lock" (click)="selectAssetForLock(list.objectInfoId)">
              </p>
              <p style="width: 10%;" *ngIf="isShowLock">{{list.objectInfoId}}</p>
              <p style="width: 15%;" *ngIf="!isShowLock">{{list.objectInfoId}}</p>
              <p style="width: 15%;"  title="{{list.givenName}}">{{list.givenName || '--'}}</p>
              <p style="width: 15%;">{{list.zone || '--'}}</p>
              <p style="width: 15%;">{{list.city || '--'}}</p>
              <p style="width: 15%;">{{list.country || '--'}}</p>
              <p style="width: 15%;">{{list.objectCondition || '--'}}</p>
              <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                <span class="options-buttons show-all-options">
                  <i data-toggle="modal" title="View and Repair" (click)="getObjectInfoById(list.objectInfoId)" data-target="#viewModal" class="bi bi-eye-fill"></i>
                  <i class="bi bi-pencil-square" (click)="getObjectInfoById(list.objectInfoId)" data-toggle="modal" data-target="#editModal" ></i>
                  <i (click)="selectDelete(list.id,list)" title="Delete" class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i>
                  <i data-toggle="modal" (click)="onSubmit()" title="Clone Asset" data-target="#cloneDeviceModal" class="bi bi-copy"></i>
                </span>
              </p>
            </div>
          </div>


          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>

          <div class="loader" *ngIf="!isLoading && objectInfoList.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>
          </div>

          <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
              [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
          </div>
        </div>
        <div class="col-lg-3 col-md-3" *ngIf="showFilter">
          <div class="filter-block">
            <div class="filters">
              <div class="filter-title">
                <p>{{ 'filters.filter' | translate }}</p>
                <div class="filter-apply-button">
                  <!-- <button (click)="resetFilter()">{{ 'filters.reset' | translate }}</button>
                  <button (click)="applyFilter()">{{ 'filters.apply' | translate }}</button> -->
                </div> 
              </div>
          


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- 
<div class="modal fade" id="openAddModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.headings.add' | translate }}
          <span data-dismiss="modal" (click)="remove()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="addForm">
          <div class="form-group">
              <label>{{ 'object-info.name' | translate }} <span class="required">*</span></label>
              <select name="" formControlName="objectTemplateId" id="" class="form-control">
                <option value="" selected disabled> -- Asset --</option>
                <option value="{{list.objectTemplateId}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
              </select>
          </div>


          <div>
            <div class="form-group">
              <label>{{ 'object-info.givenName' | translate }} <span class="required">*</span></label>
              <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()"
(cut)="false" (keydown)="filterInputByType($event, 'allText')" class="form-control" formControlName="givenName" >
            </div>

            <div class="form-group" *ngIf="list.originalCost">
              <label>{{ 'object-info.originalCost' | translate }} <span class="required" *ngIf="isOriginalCost">*</span></label>
              <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()"
(cut)="false" (keydown)="filterInputByType($event, 'number')" class="form-control" formControlName="originalCost" >
            </div>

            <div class="form-group" *ngIf="list.currentCost">
              <label>{{ 'object-info.currentCost' | translate }} </label>
              <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()"
(cut)="false" (keydown)="filterInputByType($event, 'number')" class="form-control" formControlName="currentCost" >
            </div>

            <div class="form-group">
              <label>{{ 'object-info.objectCondition' | translate }} <span class="required">*</span></label>
              <select name="" id="" formControlName="objectCondition"  class="form-control" (change)="objectConditionChange()">
                <option value="" disabled> -- select condition --</option>
                <option *ngFor="let condition of assetConditions" [value]="condition.value">{{ condition.label }}</option>
              </select>
            </div>

            <div class="form-group">
              <label>{{ 'object-info.assetStatus' | translate }}</label>
              <select name="" id="" formControlName="assetStatus"  class="form-control">
                <option value="" > -- </option>
                <option *ngFor="let list of assetStatusList" [value]="list.name">{{ list.name }}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.asset_Category' | translate }} <span class="required" *ngIf="isAsset_Category">*</span></label>
              <select name="" id="" formControlName="asset_Category"  class="form-control">
                <option value="" selected disabled> -- select asset category--</option>
                <option value="{{list.categoryName}}" *ngFor="let list of objectCategoryList">{{list.categoryName}}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.acquisitionDate' | translate }}</label>
              <input type="date" (keydown)="filterDateInput($event)" class="form-control" formControlName="acquisitionDate" >
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.salvageValue' | translate }} <span class="required" *ngIf="isSalvageValue">*</span></label>
              <input type="number" class="form-control" formControlName="salvageValue" >
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.depreciationMethod' | translate }}</label>
              <select name="" id="" formControlName="depreciationMethod"  (change)="depreciationMethodChange(depreciationMethod)" class="form-control">
                <option value="" selected disabled> -- select asset depreciation--</option>
                <option value="{{list.assetDepreciationMethodId}}" *ngFor="let list of assetDepreciationDataList">{{list.methodName}}</option>
              </select>
            </div>
            
            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.putToUseDate' | translate }} <span class="required" *ngIf="isPutToUseDate">*</span></label>
              <input type="date" [max]="todayDate" (keydown)="filterDateInput($event)" class="form-control" formControlName="putToUseDate" >
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.assetLifeNumber' | translate }} <span class="required" *ngIf="isAssetLifeNumber">*</span></label>
              <input type="number" class="form-control" (paste)="false" (contextmenu)="$event.preventDefault()"
(cut)="false" (keydown)="filterInputByType($event, 'number')" formControlName="assetLifeNumber" >
            </div>

            <div class="form-group" *ngIf="list.branch">
              <label>{{ 'object-info.branch' | translate }}</label>
              <select name="" id="" formControlName="branch"  class="form-control">
                <option value="" selected disabled> -- select branch --</option>
                <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.department">
              <label>{{ 'object-info.department' | translate }}</label>
              <select name="" id="" formControlName="department"  class="form-control">
                <option value="" selected disabled> -- select department--</option>
                <option value="{{list.departmentName}}" *ngFor="let list of departmentInfoList">{{list.departmentName}}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.make">
              <label>{{ 'object-info.make' | translate }}</label>
              <input type="text" class="form-control" formControlName="make" >
            </div>

            <div class="form-group" *ngIf="list.model">
              <label>{{ 'object-info.model' | translate }}</label>
              <input type="text" class="form-control" formControlName="model" >
            </div>

            <div class="form-group" *ngIf="list.serialNumber">
              <label>{{ 'object-info.serialNumber' | translate }}</label>
              <input type="text" class="form-control" formControlName="serialNumber" >
            </div>

            <div class="form-group" >
              <label>{{ 'object-info.location' | translate }} <span class="required">*</span></label>
              <select name="" id="" formControlName="location"  (change)="locationChange(location)" class="form-control">
                <option value="" selected disabled> -- select location --</option>
                <option value="{{loc.zone}}" *ngFor="let loc of locationFilterList">{{loc.zone}} - {{loc.city}} - {{loc.postalCode}}</option>
              </select>
            </div>
          </div>
        
        </div>
        <div class="modal-footer">
          <button type="button" id="closeAddModal" (click)="remove()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="addObjectInfo()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div> -->